import React from 'react'
import { random } from '../../../utils'


class AnimationItem extends React.PureComponent {
  
    constructor() {
        super();
        this.num = 0;
        this.state = {
            show: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== ''){
            if (this.props.content.img !== nextProps.content.img){
                this.setState({
                    show: true
                }, () => {
                    document.querySelector('.animation__item').addEventListener('webkitAnimationEnd', () => {
                        this.num = this.num + 1;
                        if (this.num === 2){
                            this.num = 0;
                            this.setState({
                                show: false
                            })
                        }
                    })
                })
            }
        }
    }

    getRandomText () {
        const texts = [`${this.props.content.name}抢到了1元课`, `${this.props.content.name}正在抢购`, `${random(1,5)}秒前抢购成功`, '抢购了9.9元优质课', `小手一抖买了${random(1,8)}节课`]
        return texts[random(0, 5)]
    }

    render() {
        if (!this.state.show){
            return null
        }

        return (
            <div className="animation__item">
                <div className="item__icon" style={{backgroundImage: `url(${this.props.content.img})`}}>

                </div>
                <div className="item__text">
                    {this.getRandomText()}
                </div>
            </div>
        )
    }
}

export default AnimationItem


// WEBPACK FOOTER //
// ./src/pages/ActivityPage/TheSecond/AnimationItem.js